<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import { openOverpanel } from '../../stores/overpanelControl';
  import { KEYCODES } from '../../utils/constants';

  let {
    headingText = undefined,
    inputPlaceHolder,
    buttonText,
    screenReaderSearchText,
    dataTestId = 'search-aside',
    closeCallback = () => {},
  } = $props();

  let input = $state();
  let button = $state();

  const handleClick = (e) => {
    openOverpanel('search', {
      closeCallback: () => {
        closeCallback();
        if (button && e.target === button) {
          button.focus();
        } else if (input) {
          input.focus();
        }
      },
    });
  };

  const handleKeydown = (e) => {
    if (
      e.keyCode === KEYCODES.ESCAPE ||
      e.keyCode === KEYCODES.TAB ||
      e.keyCode === KEYCODES.ENTER ||
      e.keyCode === KEYCODES.SHIFT
    )
      return;
    handleClick(e);
  };
</script>

<div class="flex justify-center relative bg-blue-very-light text-center" data-testid={dataTestId}>
  <div class="flex items-center justify-center relative w-full lg:max-w-6xl px-4">
    <div class="w-full py-4 md:relative flex flex-col items-center">
      {#if headingText}
        <h2 class="text-lg leading-snug mb-4">{headingText}</h2>
      {/if}
      <div class="flex flex-col relative w-full md:max-w-full text-gunmetal items-center md:z-10">
        <svg class="absolute top-4 left-4 w-4 h-4 fill-current" role="presentation">
          <use xlink:href="{SPRITESHEET_URL}#magnifying-glass" />
        </svg>
        <button
          class="w-full shadow-md rounded-sm border border-gray-gunmetal bg-white mb-4 py-2 pl-10 pr-4 leading-loose
            text-base text-gray-warm font-normal text-left placeholder-gray-warm cursor-text whitespace-nowrap
              overflow-hidden md:flex-2 items-center"
          aria-label={screenReaderSearchText}
          bind:this={input}
          onclick={handleClick}
          onkeydown={handleKeydown}
          data-testid="{dataTestId}-input"
        >
          {inputPlaceHolder}
        </button>
        <button
          class="flex-1 w-full rounded border-t border-blue-cerulean bg-blue-cerulean py-2 px-6
            text-center text-base leading-loose font-medium text-white hover-hover:hover:bg-blue-darkish hover-hover:hover:border-blue-darkish
            active:bg-blue-navy active:border-blue-navy whitespace-nowrap"
          bind:this={button}
          onclick={handleClick}
          data-testid="{dataTestId}-button"
        >
          {buttonText}
        </button>
      </div>
    </div>
  </div>
</div>
